import { useEffect } from 'react';
import { InfiniteData } from '@tanstack/react-query';
import {
  useOpInfiniteQuery,
  UseOpInfiniteQueryOptions,
} from 'utils/customHooks/useOpInfiniteQuery';
import { GetterApiEndpointNames } from 'new-components/DLS/OpDataFetchTable/OpDataFetchTable';

export const useFetchAllViaCursor = <
  T extends GetterApiEndpointNames,
  SelectData = InfiniteData<Awaited<ReturnType<Api.Client[T]>>>,
>(
  opInfiniteQueryProps: UseOpInfiniteQueryOptions<T, SelectData>,
) => {
  const result = useOpInfiniteQuery(opInfiniteQueryProps);

  const { hasNextPage, isFetchingNextPage, fetchNextPage } = result;

  // Automatically fetch the next results if there are more to get
  useEffect(() => {
    if (hasNextPage && !isFetchingNextPage) {
      fetchNextPage();
    }
  }, [fetchNextPage, hasNextPage, isFetchingNextPage]);

  return result;
};
